import { useState } from "react";

const STORAGE_KEY = "widgetPositions";

function loadPositions() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function savePosition(widgetId, pos) {
  try {
    const all = loadPositions();
    all[widgetId] = pos;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch {
    // ignore storage errors
  }
}

/**
 * Returns { position, onStop } to wire into react-draggable's controlled mode.
 * Position is persisted under the given widgetId inside the "widgetPositions" localStorage key.
 *
 * Usage:
 *   const { position, onStop } = usePersistedPosition("timer", { x: 10, y: 10 });
 *   <Draggable position={position} onStop={onStop} ...>
 */
export function usePersistedPosition(widgetId, defaultPosition = { x: 10, y: 10 }) {
  const [position, setPosition] = useState(() => {
    const saved = loadPositions();
    return saved[widgetId] ?? defaultPosition;
  });

  const onStop = (_e, data) => {
    const pos = { x: data.x, y: data.y };
    setPosition(pos);
    savePosition(widgetId, pos);
  };

  return { position, onStop };
}
